module.exports = __webpack_public_path__ + "static/media/loader.b8abaabb.svg";